<template>
  <div>
    <PageBanner />
    <Breadcrumbs />

    <section class="content">
      <div class="container">
        <h2 v-html="detail.title"></h2>
        <div>{{detail.date | moment('Y年M月')}}</div>
        <div v-html="detail.content"></div>
      </div>
      <div
        class="container-fluid mt-3"
        v-if="detail.gallery"
      >
        <div class="row no-gutters">
          <div
            class="col-lg-3 col-md-4 col-sm-6"
            v-for="(img, index) in detail.gallery"
            :key="index"
          >
            <a
              ref="popup"
              :href="require('@/assets/img/'+ img.path)"
              :title="img.caption"
              class="gallery"
            >
              <img
                :src="require('@/assets/img/'+ img.path)"
                :alt="img.caption"
                class="img-fluid"
              >
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import PageBanner from "@/components/pageBanner.vue";
  import Breadcrumbs from "@/components/breadcrumbs.vue";
  import newsData from "@/assets/data/news.json";
  export default {
    name: "NewsDetail",
    data() {
      return {
        news: newsData
      };
    },
    computed: {
      detailID: function() {
        let self = this;
        return self.$route.params.id;
      },
      detail: function() {
        let self = this;
        let result = {};
        self.news.forEach(function(entry) {
            if(entry.id == self.detailID){
              result = entry;
            }
        });
        return result;
      }
    },
    mounted: function mounted() {
      if (this.$refs.popup) {
        $(this.$refs.popup).magnificPopup({
          type: "image",
          removalDelay: 300,
          mainClass: "mfp-fade",
          gallery: {
            enabled: true
          },
          titleSrc: "alt"
        });
      }
    },
    components: {
      PageBanner,
      Breadcrumbs
    }
  };
</script>